import {z} from "zod/v4-mini"

export const space = z.enum(["OBJECT", "WORLD"])

export type Space = "OBJECT" | "WORLD"
